var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3728 22C15.1342 22 17.6342 20.8807 19.4439 19.0711C21.2535 17.2614 22.3728 14.7614 22.3728 12C22.3728 9.2386 21.2535 6.7386 19.4439 4.92893C17.6342 3.11929 15.1342 2 12.3728 2C9.6114 2 7.1114 3.11929 5.30173 4.92893C3.49209 6.7386 2.3728 9.2386 2.3728 12C2.3728 14.7614 3.49209 17.2614 5.30173 19.0711C7.1114 20.8807 9.6114 22 12.3728 22Z",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3728 14.3125V12.3125C14.0297 12.3125 15.3728 10.9694 15.3728 9.3125C15.3728 7.65565 14.0297 6.3125 12.3728 6.3125C10.716 6.3125 9.3728 7.65565 9.3728 9.3125",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1228 17.5625C13.1228 17.9767 12.787 18.3125 12.3728 18.3125C11.9586 18.3125 11.6228 17.9767 11.6228 17.5625C11.6228 17.1483 11.9586 16.8125 12.3728 16.8125C12.787 16.8125 13.1228 17.1483 13.1228 17.5625Z",
    fill: "none",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkIcon);
export default __webpack_public_path__ + "static/media/question-mark-icon.003882e9fcfa1e65696ef6b711aeb729.svg";
export { ForwardRef as ReactComponent };